const preTitle = {
    fontFamily: 'SackersGothicStd, sans-serif',
    fontSizeSmall: '14px',
    fontSizeMedium: '16px',
    lineHeightSmall: '24px',
    lineHeightMedium: '24px',
    fontWeight: '850',
  }
  
  const title = {
    fontFamily: 'SackersGothicStd, sans-serif',
    fontSizeSmall: '30px',
    fontSizeMedium: '50px',
    lineHeightSmall: '40px',
    lineHeightMedium: '60px',
    widthSmall: '227px',
    widthMedium: '414px',
    fontWeight: '850',
  }
  
  const textStyles = {
    name: '4',
    type: 'Paragraph'
  }

  const loyaltyHero = {
    preTitle,
    title,
    textStyles
  }

  export default loyaltyHero